import React from 'react';

const pageStyle = { maxWidth: '720px', margin: '0 auto', padding: '3rem 1.5rem', lineHeight: 1.7, color: '#2d3436' };
const h1Style = { fontSize: '1.8rem', marginBottom: '2rem' };
const h2Style = { fontSize: '1.15rem', marginTop: '2rem', marginBottom: '0.5rem' };

const PolitiqueConfidentialite = () => (
  <div style={pageStyle}>
    <a href="/" style={{ fontSize: '0.85rem' }}>← Retour à l'accueil</a>
    <h1 style={h1Style}>Politique de confidentialité</h1>
    <p style={{ fontSize: '0.85rem', color: '#636e72' }}>Dernière mise à jour : 3 août 2026</p>

    <h2 style={h2Style}>Qui traite vos données ?</h2>
    <p>
      Le responsable du traitement est la société Passerelle (SASU), représentée par Anne
      Varnerot, joignable à <a href="mailto:anne@mypasserelle.com">anne@mypasserelle.com</a>.
    </p>

    <h2 style={h2Style}>Quelles données collectons-nous, et pourquoi ?</h2>
    <p>
      <strong>Formulaire « devenir testeur »</strong> : prénom et nom, adresse email, numéro de
      téléphone, profil (parent, patient, aidant ou professionnel) et, si vous le souhaitez, vos
      attentes vis-à-vis de Passerelle. Ces données servent uniquement à vous recontacter pour
      la phase de test de la plateforme. Base légale : votre consentement.
    </p>
    <p>
      <strong>Newsletter</strong> : adresse email, utilisée uniquement pour vous envoyer les
      actualités de Passerelle. Vous pouvez vous désinscrire à tout moment.
    </p>
    <p>
      <strong>Important :</strong> ne transmettez aucune information médicale ou relative à la
      santé (la vôtre ou celle d'un proche) via ces formulaires. Ces informations n'auront leur
      place que dans la plateforme Passerelle, hébergée sur une infrastructure certifiée
      Hébergeur de Données de Santé (HDS).
    </p>

    <h2 style={h2Style}>Où sont stockées vos données ?</h2>
    <p>
      Sur des serveurs Supabase situés dans l'Union européenne (Stockholm, Suède). Elles ne
      sont ni vendues, ni cédées, ni transmises à des tiers.
    </p>

    <h2 style={h2Style}>Combien de temps ?</h2>
    <p>
      Les données du formulaire testeur sont conservées pendant la durée de la phase de test,
      et au maximum 3 ans après votre dernier contact avec nous. Les emails newsletter sont
      conservés jusqu'à votre désinscription.
    </p>

    <h2 style={h2Style}>Cookies</h2>
    <p>
      Le site n'utilise ni cookies publicitaires, ni traceurs d'audience tiers.
    </p>

    <h2 style={h2Style}>Vos droits</h2>
    <p>
      Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement,
      d'opposition et de portabilité de vos données. Pour l'exercer, écrivez à{' '}
      <a href="mailto:anne@mypasserelle.com">anne@mypasserelle.com</a> — réponse sous 30 jours.
      Vous pouvez également adresser une réclamation à la CNIL (
      <a href="https://www.cnil.fr" target="_blank" rel="noreferrer">cnil.fr</a>).
    </p>
  </div>
);

export default PolitiqueConfidentialite;
